import { SECTOR_META } from './map-utils';
import { OCC_CHIP_TO_SECTOR } from './occupation-utils';
import type { OccupationalGroup } from '../types/occupation';

/**
 * Canonical list of occupational-group options for the
 * Rankings / Detail / Providers filter dropdowns.
 *
 * Derived once at module load from the chip <-> sector mapping the
 * map page uses (`OCC_CHIP_TO_SECTOR`) so every filter dropdown,
 * map sidebar, and URL chip speaks the same vocabulary. When
 * Georgetown ships per-occupation data via `/api/occupations`, the
 * static list retires and the API drives this directly.
 *
 * Each entry:
 *   - `id`    — stable URL-friendly chip slug (`healthcare-professional-and-technical`)
 *   - `name`  — display name shown in the dropdown
 *   - `color` — sector swatch, sourced from `SECTOR_META` when the
 *               group maps to a known sector; falls back to black
 *               (`#000000`) for the defensive case so consumers can
 *               always render a swatch without a null check.
 */
export const OCCUPATIONAL_GROUPS: ReadonlyArray<OccupationalGroup> =
  (Object.entries(OCC_CHIP_TO_SECTOR) as Array<[string, string]>).map(
    ([id, name]) => {
      const sector = SECTOR_META.find((s) => s.name === name);
      return { id, name, color: sector?.color ?? '#000000' };
    },
  );
